import { initializeTable } from '../tables';
import RowContextMenuButtonColumn from '../formatters/RowContextMenuButtonColumn';
import { getCookie } from '../../utils';
import { addAlert } from '../../alerts';
import { postPrompt } from '../../prompts';

export default function initializeExecutionsTable({ ...options }) {
    const rootElement = document.querySelector('#executionsTable');

    const stationType = rootElement.dataset.stationType;
    const forcedFilter = [];
    const pillsContainerSelector = '.active-filters-container';

    if (stationType) {
        forcedFilter.push({
            field: 'station_type',
            type: '=',
            value: stationType,
        });
    }

    initializeTable({
        tableElement: rootElement,
        filtersElement: document.querySelector(
            '#executionsFilters .form-fields',
        ),
        tabsElement: document.querySelector('.table-tabs'),
        ajaxURL: rootElement.dataset.ajaxUrl,
        forcedFilter: forcedFilter,
        pillsConfig: {
            containerSelector: pillsContainerSelector,
            ignoreFields: ['station_type', 'is_finished'],
        },
        rowContextMenu: function (e, row) {
            const rowData = row.getData();
            let menu = [
                {
                    label: rowData.is_finished
                        ? gettext('Wznów proces')
                        : gettext('Kontynuuj proces'),
                    action: function (e, row) {
                        if (rowData.is_finished) {
                            postPrompt({
                                options: {
                                    html:
                                        gettext(
                                            'Czy na pewno chcesz wznowić ten proces?',
                                        ) +
                                        gettext(
                                            'Umożliwi to jego ponowne wykonanie i aktualizację.',
                                        ),
                                },
                                url: `/api/execution/${rowData.id}/restart`,
                                successAction: function () {
                                    addAlert(
                                        'success',
                                        gettext('Proces został wznowiony.'),
                                    );
                                    window.location.href = rowData.update_url;
                                },
                                failedAction: function (error) {
                                    const message =
                                        error?.data?.message ||
                                        error?.message ||
                                        gettext(
                                            'Wystąpił błąd podczas wznawiania procesu.',
                                        );
                                    addAlert('error', message);
                                },
                            });
                        } else {
                            window.location.href = rowData.update_url;
                        }
                    },
                },
                stationType === 'DD'
                    ? {
                          label: gettext('Katalogowanie podzespołów'),
                          disabled: !rowData.is_finished,
                          action: function (e, row) {
                              window.location.href = rowData.catalog_url;
                          },
                      }
                    : null,
                {
                    label: gettext('Usuń'),
                    disabled: rowData.is_finished,
                    action: async function (e, row) {
                        const response = await fetch(
                            `/api/execution/${rowData.id}`,
                            {
                                method: 'DELETE',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-CSRFToken': getCookie('csrftoken'),
                                },
                            },
                        );
                        const data = await response.json();
                        if (response.ok) {
                            addAlert('success', data.message);
                            row.delete();
                        } else {
                            addAlert('error', data.message);
                        }
                    },
                },
            ];
            menu = menu.filter((item) => item);
            return menu;
        },
        columns: [
            { title: '#', formatter: 'rownum', width: 60, headerSort: false },
            {
                title: gettext('Urządzenie'),
                field: 'device_enova_id',
                resizable: false,
                visible: stationType === 'DD',
                width: 140,
                accessor: (value, data) => data.device?.enova_id,
            },
            {
                title: gettext('Model'),
                field: 'device_models',
                resizable: false,
                width: 120,
                visible: stationType === 'DD',
                accessor: (value, data) => data.device?.enova_data?.model,
            },
            {
                title: gettext('Producent urządzenia'),
                field: 'device_manufacturer',
                resizable: false,
                visible: stationType === 'DD',
                accessor: (value, data) =>
                    data.device?.enova_data?.manufacturer,
            },
            {
                title: gettext('Grupa urządzenia'),
                field: 'device_group',
                resizable: false,
                visible: stationType === 'DD',
                accessor: (value, data) => data.device?.enova_data?.group,
            },
            {
                title: gettext('Typ urządzenia'),
                field: 'device_type',
                resizable: false,
                visible: stationType === 'DD',
                accessor: (value, data) => data.device?.enova_data?.type,
            },
            {
                title: gettext('Podzespół'),
                field: 'component_enova_id',
                resizable: false,
                visible: stationType !== 'DD',
                accessor: (value, data) => data.component?.enova_id,
            },
            {
                title: gettext('Grupa podzespołu'),
                field: 'component_group',
                resizable: false,
                visible: stationType !== 'DD',
                accessor: (value, data) => data.component?.enova_data?.group,
            },
            {
                title: gettext('Typ podzespołu'),
                field: 'component_type',
                resizable: false,
                visible: stationType !== 'DD',
                accessor: (value, data) => data.component?.enova_data?.type,
            },
            {
                title: gettext('Początek procesu'),
                field: 'start_time',
                formatter: 'datetime',
                formatterParams: {
                    inputFormat: 'iso',
                    outputFormat: 'dd-MM-yy HH:mm',
                },
                resizable: false,
                sorter: 'datetime',
                sorterParams: {
                    format: 'iso',
                    alignEmptyValues: 'top',
                },
            },
            {
                title: gettext('Koniec procesu'),
                field: 'end_time',
                formatter: 'datetime',
                formatterParams: {
                    inputFormat: 'iso',
                    outputFormat: 'dd-MM-yy HH:mm',
                },
                width: 140,
                resizable: false,
                sorter: 'datetime',
                sorterParams: {
                    format: 'iso',
                    alignEmptyValues: 'top',
                },
            },
            {
                title: gettext('Użytkownik'),
                field: 'user_name',
                resizable: false,
                width: 140,
            },
            {
                title: gettext('Akcja'),
                resizable: false,
                headerSort: false,
                width: 100,
                formatter: RowContextMenuButtonColumn,
            },
        ],
        ...options,
    });
}
